import { render, staticRenderFns } from "./AccountRewards.vue?vue&type=template&id=4f5302c8&"
import script from "./AccountRewards.vue?vue&type=script&lang=js&"
export * from "./AccountRewards.vue?vue&type=script&lang=js&"
import style0 from "./AccountRewards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports